import React from 'react'

const Controllers = ({next, prev}) => {
  return <div className='controllers'>
    <button className='controllers-button' onClick={prev}>Prev</button>
    <button className='controllers-button' onClick={next}>Next</button>
  </div>
}

export default Controllers